import { Injectable } from '@angular/core';

interface SvgIcon {
  svgPath: string;
  viewBox?: string;
}

@Injectable({ providedIn: 'root' })
export class IconService {
  private icons: Record<string, SvgIcon> = {};

  registerIcon(key: string, icon: SvgIcon): void {
    this.icons[key] = icon;
  }

  getIcon(iconName: string): SvgIcon | undefined {
    return this.icons[iconName];
  }

  constructor() {
    this.registerIcon('24-7-er-outlined', {
      svgPath: '/assets/icon-set/24-7-er-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('acquisition-outlined', {
      svgPath: '/assets/icon-set/acquisition-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('add-circle-solid', {
      svgPath: '/assets/icon-set/add-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('alarm', {
      svgPath: '/assets/icon-set/alarm.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('angle-down-solid', {
      svgPath: '/assets/icon-set/angle-down-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('angle-left-solid', {
      svgPath: '/assets/icon-set/angle-left-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('angle-right-solid', {
      svgPath: '/assets/icon-set/angle-right-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('angle-up-solid', {
      svgPath: '/assets/icon-set/angle-up-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-back', {
      svgPath: '/assets/icon-set/arrow-back.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-caro-left', {
      svgPath: '/assets/icon-set/arrow-caro-left.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-caro-right', {
      svgPath: '/assets/icon-set/arrow-caro-right.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-down', {
      svgPath: '/assets/icon-set/arrow-down.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-forward', {
      svgPath: '/assets/icon-set/arrow-forward.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-right-circle-solid', {
      svgPath: '/assets/icon-set/arrow-right-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-right-solid', {
      svgPath: '/assets/icon-set/arrow-right-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-unfold', {
      svgPath: '/assets/icon-set/arrow-unfold.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-up-circle-solid', {
      svgPath: '/assets/icon-set/arrow-up-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-up-right-from-square-solid', {
      svgPath: '/assets/icon-set/arrow-up-right-from-square-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('arrow-up', {
      svgPath: '/assets/icon-set/arrow-up.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('badge-outlined', {
      svgPath: '/assets/icon-set/badge-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('ban-solid', {
      svgPath: '/assets/icon-set/ban-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('bank', {
      svgPath: '/assets/icon-set/bank.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('batteries-outlined', {
      svgPath: '/assets/icon-set/batteries-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('bed', {
      svgPath: '/assets/icon-set/bed.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('bed-outline', {
      svgPath: '/assets/icon-set/bed-outline.svg#shape',
      viewBox: '0 0 58 54',
    });
    this.registerIcon('bell-solid', {
      svgPath: '/assets/icon-set/bell-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('bell-dot-solid', {
      svgPath: '/assets/icon-set/bell-dot-solid.svg#shape',
      viewBox: '0 0 20 20',
    });
    this.registerIcon('blog-outlined', {
      svgPath: '/assets/icon-set/blog-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('boardroom-outlined', {
      svgPath: '/assets/icon-set/boardroom-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('bookmark-outline', {
      svgPath: '/assets/icon-set/bookmark-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('bookmark-solid', {
      svgPath: '/assets/icon-set/bookmark-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('brand-loyalty-outlined', {
      svgPath: '/assets/icon-set/brand-loyalty-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('briefcase-solid', {
      svgPath: '/assets/icon-set/briefcase-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('building-columns-solid', {
      svgPath: '/assets/icon-set/building-columns-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('bulk-waste-outlined', {
      svgPath: '/assets/icon-set/bulk-waste-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('bulldozer-outlined', {
      svgPath: '/assets/icon-set/bulldozer-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('business-outlined', {
      svgPath: '/assets/icon-set/business-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('calendar-day-outline', {
      svgPath: '/assets/icon-set/calendar-day-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('calendar-day-solid', {
      svgPath: '/assets/icon-set/calendar-day-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('calendar-days-solid', {
      svgPath: '/assets/icon-set/calendar-days-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('calendar-outlined', {
      svgPath: '/assets/icon-set/calendar-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('calendar-solid', {
      svgPath: '/assets/icon-set/calendar-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('camera-solid', {
      svgPath: '/assets/icon-set/camera-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('car-outline', {
      svgPath: '/assets/icon-set/car-outline.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('cardboard-outlined', {
      svgPath: '/assets/icon-set/cardboard-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('caret-down-solid', {
      svgPath: '/assets/icon-set/caret-down-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('caret-right-solid', {
      svgPath: '/assets/icon-set/caret-right-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('caret-up-solid', {
      svgPath: '/assets/icon-set/caret-up-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cart-plus-solid', {
      svgPath: '/assets/icon-set/cart-plus-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cart-solid', {
      svgPath: '/assets/icon-set/cart-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cart-trash-outlined', {
      svgPath: '/assets/icon-set/cart-trash-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('carton-outlined', {
      svgPath: '/assets/icon-set/carton-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('cc-amex', {
      svgPath: '/assets/icon-set/cc-amex.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cc-discover', {
      svgPath: '/assets/icon-set/cc-discover.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cc-mastercard', {
      svgPath: '/assets/icon-set/cc-mastercard.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cc-regular', {
      svgPath: '/assets/icon-set/cc-regular.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cc-visa', {
      svgPath: '/assets/icon-set/cc-visa.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('charitable-giving-outlined', {
      svgPath: '/assets/icon-set/charitable-giving-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('check-circle-solid', {
      svgPath: '/assets/icon-set/check-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('check', {
      svgPath: '/assets/icon-set/check.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('checklist-outlined', {
      svgPath: '/assets/icon-set/checklist-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('checkmark-outlined', {
      svgPath: '/assets/icon-set/checkmark-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('chevron-down-solid', {
      svgPath: '/assets/icon-set/chevron-down-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-down', {
      svgPath: '/assets/icon-set/chevron-down.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-down-circle', {
      svgPath: '/assets/icon-set/chevron-down-circle.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-left-circle', {
      svgPath: '/assets/icon-set/chevron-left-circle.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-left-solid', {
      svgPath: '/assets/icon-set/chevron-left-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-right-circle', {
      svgPath: '/assets/icon-set/chevron-right-circle.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-right-solid', {
      svgPath: '/assets/icon-set/chevron-right-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-up-solid', {
      svgPath: '/assets/icon-set/chevron-up-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('chevron-up', {
      svgPath: '/assets/icon-set/chevron-up.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('circle-outline', {
      svgPath: '/assets/icon-set/circle-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('circle-regular', {
      svgPath: '/assets/icon-set/circle-regular.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('clipboard-outlined', {
      svgPath: '/assets/icon-set/clipboard-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('clock-outlined', {
      svgPath: '/assets/icon-set/clock-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('clock-solid', {
      svgPath: '/assets/icon-set/clock-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('close-circle-solid', {
      svgPath: '/assets/icon-set/close-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('cloud-sun', {
      svgPath: '/assets/icon-set/cloud-sun.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('comments-solid', {
      svgPath: '/assets/icon-set/comments-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('communication-bubble-outlined', {
      svgPath: '/assets/icon-set/communication-bubble-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('community-outlined', {
      svgPath: '/assets/icon-set/community-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('compactor-delivery', {
      svgPath: '/assets/icon-set/compactor-dumpster-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('compactor-rental-outline', {
      svgPath: '/assets/icon-set/compactor-rental-outline.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('compass-arrow', {
      svgPath: '/assets/icon-set/compass-arrow.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('compass', {
      svgPath: '/assets/icon-set/compass.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('compliance-outlined', {
      svgPath: '/assets/icon-set/compliance-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('compress-solid', {
      svgPath: '/assets/icon-set/compress-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('computer-outlined', {
      svgPath: '/assets/icon-set/computer-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('computer', {
      svgPath: '/assets/icon-set/computer.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('construction-outlined', {
      svgPath: '/assets/icon-set/construction-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('cross-functional-huddle-outlined', {
      svgPath: '/assets/icon-set/cross-functional-huddle-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('csr-outlined', {
      svgPath: '/assets/icon-set/csr-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('customer-user-outlined', {
      svgPath: '/assets/icon-set/customer-user-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('customers-users-outlined', {
      svgPath: '/assets/icon-set/customers-users-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('dashboard-solid', {
      svgPath: '/assets/icon-set/dashboard-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('disabled', {
      svgPath: '/assets/icon-set/disabled.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('dollar-sign-solid', {
      svgPath: '/assets/icon-set/dollar-sign-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('dont-bag-it', {
      svgPath: '/assets/icon-set/dont-bag-it-outline.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('dont-bag-it-outlined', {
      svgPath: '/assets/icon-set/dont-bag-it-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('driver-outlined', {
      svgPath: '/assets/icon-set/driver-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('drum-steelpan-outline', {
      svgPath: '/assets/icon-set/drum-steelpan-outline.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('dumpster-outlined', {
      svgPath: '/assets/icon-set/dumpster-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('e&p-outlined', {
      svgPath: '/assets/icon-set/e&p-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('edit-square-outline', {
      svgPath: '/assets/icon-set/edit-square-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('edit', {
      svgPath: '/assets/icon-set/edit.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('electronic-waste-outlined', {
      svgPath: '/assets/icon-set/electronic-waste-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('ellipses', {
      svgPath: '/assets/icon-set/ellipses.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('email-outlined', {
      svgPath: '/assets/icon-set/email-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('empty-clean-dry', {
      svgPath: '/assets/icon-set/empty-clean-dry-outline.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('energy-services-outlined', {
      svgPath: '/assets/icon-set/energy-services-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('engineer-outlined', {
      svgPath: '/assets/icon-set/engineer-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('envelope-fill', {
      svgPath: '/assets/icon-set/envelope-fill.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('envelope-outline', {
      svgPath: '/assets/icon-set/envelope-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('error-outline', {
      svgPath: '/assets/icon-set/error-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('exclamation-circle-solid', {
      svgPath: '/assets/icon-set/exclamation-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('exclamation-solid', {
      svgPath: '/assets/icon-set/exclamation-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('exclamation-triangle-solid', {
      svgPath: '/assets/icon-set/exclamation-triangle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('exclamation', {
      svgPath: '/assets/icon-set/exclamation.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('executive-outlined', {
      svgPath: '/assets/icon-set/executive-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('expand-solid', {
      svgPath: '/assets/icon-set/expand-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('eye-slash-outline', {
      svgPath: '/assets/icon-set/eye-slash-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('eye-slash-solid', {
      svgPath: '/assets/icon-set/eye-slash-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('eye-solid', {
      svgPath: '/assets/icon-set/eye-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('facebook', {
      svgPath: '/assets/icon-set/facebook.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('file-download', {
      svgPath: '/assets/icon-set/file-download.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('file-lines-solid', {
      svgPath: '/assets/icon-set/file-lines-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('file-pdf-regular', {
      svgPath: '/assets/icon-set/file-pdf-regular.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('file-pdf-solid', {
      svgPath: '/assets/icon-set/file-pdf-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('file-solid', {
      svgPath: '/assets/icon-set/file-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('file-upload', {
      svgPath: '/assets/icon-set/file-upload.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('filter-outline', {
      svgPath: '/assets/icon-set/filter-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('flag-oulline', {
      svgPath: '/assets/icon-set/flag-oulline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('fluorescent-bulb-outlined', {
      svgPath: '/assets/icon-set/fluorescent-bulb-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('folder-solid', {
      svgPath: '/assets/icon-set/folder-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('forum-solid', {
      svgPath: '/assets/icon-set/forum-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('fridge', {
      svgPath: '/assets/icon-set/fridge.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('fridge-outline', {
      svgPath: '/assets/icon-set/fridge-outline.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('front-loader-outlined', {
      svgPath: '/assets/icon-set/front-loader-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('furniture', {
      svgPath: '/assets/icon-set/furniture.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('furniture-outline', {
      svgPath: '/assets/icon-set/furniture-outline.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('gas-pump-outline', {
      svgPath: '/assets/icon-set/gas-pump-outline.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('gear-solid', {
      svgPath: '/assets/icon-set/gear-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('glass-bottle-outlined', {
      svgPath: '/assets/icon-set/glass-bottle-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('globe-outlined', {
      svgPath: '/assets/icon-set/globe-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('grocery-outlined', {
      svgPath: '/assets/icon-set/grocery-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('handshake-outlined', {
      svgPath: '/assets/icon-set/handshake-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('hazardous-waste-outlined', {
      svgPath: '/assets/icon-set/hazardous-waste-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('healthcare-outlined', {
      svgPath: '/assets/icon-set/healthcare-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('heart-outlined', {
      svgPath: '/assets/icon-set/heart-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('heart-solid', {
      svgPath: '/assets/icon-set/heart-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('holidays-outlined', {
      svgPath: '/assets/icon-set/holidays-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('home-solid', {
      svgPath: '/assets/icon-set/home-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('house-outlined', {
      svgPath: '/assets/icon-set/house-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('inclement-weather-outlined', {
      svgPath: '/assets/icon-set/inclement-weather-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('info-circle-solid', {
      svgPath: '/assets/icon-set/info-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('info-solid', {
      svgPath: '/assets/icon-set/info-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('infopro-outlined', {
      svgPath: '/assets/icon-set/infopro-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('information-outlined', {
      svgPath: '/assets/icon-set/information-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('instagram', {
      svgPath: '/assets/icon-set/instagram.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('know-what-to-throw-outlined', {
      svgPath: '/assets/icon-set/know-what-to-throw-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('landfill-outlined', {
      svgPath: '/assets/icon-set/landfill-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('layer-group-solid', {
      svgPath: '/assets/icon-set/layer-group-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('leadership-outlined', {
      svgPath: '/assets/icon-set/leadership-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('leaf-solid', {
      svgPath: '/assets/icon-set/leaf-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('light-bulb-outlined', {
      svgPath: '/assets/icon-set/light-bulb-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('link', {
      svgPath: '/assets/icon-set/link.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('linkedin', {
      svgPath: '/assets/icon-set/linkedin.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('list-solid', {
      svgPath: '/assets/icon-set/list-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('list-ul-solid', {
      svgPath: '/assets/icon-set/list-ul-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('list', {
      svgPath: '/assets/icon-set/list.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('location-dot-solid', {
      svgPath: '/assets/icon-set/location-dot-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('lock-dot-solid', {
      svgPath: '/assets/icon-set/lock-dot-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('lock-solid', {
      svgPath: '/assets/icon-set/lock-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('login', {
      svgPath: '/assets/icon-set/login.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('logout', {
      svgPath: '/assets/icon-set/logout.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('magnifying-glass-outlined', {
      svgPath: '/assets/icon-set/magnifying-glass-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('manufacturing-outlined', {
      svgPath: '/assets/icon-set/manufacturing-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('map-pin', {
      svgPath: '/assets/icon-set/map-pin.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('medical-waste-outlined', {
      svgPath: '/assets/icon-set/medical-waste-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('menu-navigation', {
      svgPath: '/assets/icon-set/menu-navigation.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('minus-solid', {
      svgPath: '/assets/icon-set/minus-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('minus-square-solid', {
      svgPath: '/assets/icon-set/minus-square-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('mobile-phone', {
      svgPath: '/assets/icon-set/mobile-phone.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('mpu-outlined', {
      svgPath: '/assets/icon-set/mpu-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('municipal-government-outlined', {
      svgPath: '/assets/icon-set/municipal-government-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('navigation-search', {
      svgPath: '/assets/icon-set/navigation-search.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('news-outlined', {
      svgPath: '/assets/icon-set/news-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('office-outlined', {
      svgPath: '/assets/icon-set/office-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('operations-outlined', {
      svgPath: '/assets/icon-set/operations-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('organic-waste-outlined', {
      svgPath: '/assets/icon-set/organic-waste-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('paper-outlined', {
      svgPath: '/assets/icon-set/paper-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('paperclip', {
      svgPath: '/assets/icon-set/paperclip.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('pay-bill-outlined', {
      svgPath: '/assets/icon-set/pay-bill-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('pen-to-square-solid', {
      svgPath: '/assets/icon-set/pen-to-square-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('person-solid', {
      svgPath: '/assets/icon-set/person-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('phone-mobile-outlined', {
      svgPath: '/assets/icon-set/phone-mobile-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('phone-outlined', {
      svgPath: '/assets/icon-set/phone-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('phone-solid', {
      svgPath: '/assets/icon-set/phone-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('phone', {
      svgPath: '/assets/icon-set/phone.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('pinterest', {
      svgPath: '/assets/icon-set/pinterest.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('plane-arrival', {
      svgPath: '/assets/icon-set/plane-arrival.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('airplane-take-off', {
      svgPath: '/assets/icon-set/plane-outline.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('plastic-bottle-outlined', {
      svgPath: '/assets/icon-set/plastic-bottle-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('plastic-grouping-outlined', {
      svgPath: '/assets/icon-set/plastic-grouping-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('play-circle-solid', {
      svgPath: '/assets/icon-set/play-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('play-solid', {
      svgPath: '/assets/icon-set/play-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('play', {
      svgPath: '/assets/icon-set/play.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('plus-solid', {
      svgPath: '/assets/icon-set/plus-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('plus-square-solid', {
      svgPath: '/assets/icon-set/plus-square-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('portable-toilet-outlined', {
      svgPath: '/assets/icon-set/portable-toilet-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('print-solid', {
      svgPath: '/assets/icon-set/print-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('print', {
      svgPath: '/assets/icon-set/print.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('question-circle-outline', {
      svgPath: '/assets/icon-set/question-circle-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('question-circle-solid', {
      svgPath: '/assets/icon-set/question-circle-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('recurring-service-outlined', {
      svgPath: '/assets/icon-set/recurring-service-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('recycle', {
      svgPath: '/assets/icon-set/recycle.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('recycling-facility-outlined', {
      svgPath: '/assets/icon-set/recycling-facility-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('recycling-symbol-outlined', {
      svgPath: '/assets/icon-set/recycling-symbol-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('refresh', {
      svgPath: '/assets/icon-set/refresh.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('reliability-outlined', {
      svgPath: '/assets/icon-set/reliability-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('republic-services-app-outlined', {
      svgPath: '/assets/icon-set/republic-services-app-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('restaurant-outlined', {
      svgPath: '/assets/icon-set/restaurant-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('retail-outlined', {
      svgPath: '/assets/icon-set/retail-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('revenue-outlined', {
      svgPath: '/assets/icon-set/revenue-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('roll-off-dumpster-outlined', {
      svgPath: '/assets/icon-set/roll-off-dumpster-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('roll-off-truck-outlined', {
      svgPath: '/assets/icon-set/roll-off-truck-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('rotate-left-solid', {
      svgPath: '/assets/icon-set/rotate-left-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('rotate-right-solid', {
      svgPath: '/assets/icon-set/rotate-right-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('rotate-solid', {
      svgPath: '/assets/icon-set/rotate-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('routes-outlined', {
      svgPath: '/assets/icon-set/routes-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('runs-efficiently-outlined', {
      svgPath: '/assets/icon-set/runs-efficiently-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('safety-outlined', {
      svgPath: '/assets/icon-set/safety-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('sales-outlined', {
      svgPath: '/assets/icon-set/sales-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('security-outlined', {
      svgPath: '/assets/icon-set/security-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('semi-outlined', {
      svgPath: '/assets/icon-set/semi-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('share-ios', {
      svgPath: '/assets/icon-set/share-ios.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('shopping-basket-solid', {
      svgPath: '/assets/icon-set/shopping-basket-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('shopping-cart-outline', {
      svgPath: '/assets/icon-set/shopping-cart-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('shopping-cart-solid', {
      svgPath: '/assets/icon-set/shopping-cart-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('side-loader-outlined', {
      svgPath: '/assets/icon-set/side-loader-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('small-business-outlined', {
      svgPath: '/assets/icon-set/small-business-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('soda-can-outlined', {
      svgPath: '/assets/icon-set/soda-can-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('solid-waste-outlined', {
      svgPath: '/assets/icon-set/solid-waste-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('special-waste-outlined', {
      svgPath: '/assets/icon-set/special-waste-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('spinner-solid', {
      svgPath: '/assets/icon-set/spinner-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('square-regular', {
      svgPath: '/assets/icon-set/square-regular.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('square-solid', {
      svgPath: '/assets/icon-set/square-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('star-solid', {
      svgPath: '/assets/icon-set/star-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('sustainability-outlined', {
      svgPath: '/assets/icon-set/sustainability-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('tech-outlined', {
      svgPath: '/assets/icon-set/tech-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('thumbs-down-solid', {
      svgPath: '/assets/icon-set/thumbs-down-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('thumbs-up-solid', {
      svgPath: '/assets/icon-set/thumbs-up-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('tin-can-outlined', {
      svgPath: '/assets/icon-set/tin-can-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('transfer-station-outlined', {
      svgPath: '/assets/icon-set/transfer-station-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('trash-bag-outlined', {
      svgPath: '/assets/icon-set/trash-bag-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('trash-solid', {
      svgPath: '/assets/icon-set/trash-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('trophy-outlined', {
      svgPath: '/assets/icon-set/trophy-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('truck-trash-solid', {
      svgPath: '/assets/icon-set/truck-trash-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('twitter', {
      svgPath: '/assets/icon-set/twitter.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('unserviceable-container-outlined', {
      svgPath: '/assets/icon-set/unserviceable-container-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('us-map-outlined', {
      svgPath: '/assets/icon-set/us-map-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('user-graduate-outline', {
      svgPath: '/assets/icon-set/user-graduate-outline.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('user-outline', {
      svgPath: '/assets/icon-set/user-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('user-solid', {
      svgPath: '/assets/icon-set/user-solid.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('venue-outlined', {
      svgPath: '/assets/icon-set/venue-outlined.svg#shape',
      viewBox: '0 0 54 54',
    });
    this.registerIcon('warehouse-outline', {
      svgPath: '/assets/icon-set/warehouse-outline.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('water-outline', {
      svgPath: '/assets/icon-set/water-outline.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('X', {
      svgPath: '/assets/icon-set/X.svg#shape',
      viewBox: '0 0 24 24',
    });
    this.registerIcon('yard-waste-outlined', {
      svgPath: '/assets/icon-set/yard-waste-outlined.svg#shape',
      viewBox: '0 0 55 55',
    });
    this.registerIcon('youtube', {
      svgPath: '/assets/icon-set/youtube.svg#shape',
      viewBox: '0 0 24 24',
    });
  }
}
